import { JTLCredentials } from '@/core/types';
import { useTranslation } from 'react-i18next';
import { JTLSecretKey } from './JTLSecretKey';
import { JTLCredentialsStatusEnum } from '@/core/enums';
import classNames from 'classnames';
import { JTLStatus } from '../Integrations/JTLStatus';
import CopyIcon from '@/icons/copy.svg?react';
import Button from '../Button';
import { Spinner } from '../Spinner';

interface Props {
  password: string;
  jtlCredentials?: JTLCredentials;
  onClickCopy: (text: string, message: string) => () => void;
  onClickGenerate: () => void;
  isGenerating: boolean;
}

export const ConnectJTLSidebar = ({
  password,
  jtlCredentials,
  onClickCopy,
  onClickGenerate,
  isGenerating,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      style={{ maxWidth: 352, position: 'sticky', top: '60px' }}
      className={classNames(
        'mt-4 rounded-lg border-2 border-white bg-white p-4 lg:ml-auto lg:mt-0',
        {
          '!border-red-500':
            jtlCredentials?.status === JTLCredentialsStatusEnum.ConnectionLost,
        }
      )}
    >
      <h4 className='Title--sm pb-3 font-extrabold'>
        {t('countX login information')}
      </h4>
      <div className='space-y-4 divide-y'>
        {jtlCredentials ? (
          <JTLStatus
            credentials={jtlCredentials}
            className={classNames('font-semibold', {
              'text-red-500':
                jtlCredentials?.status ===
                JTLCredentialsStatusEnum.ConnectionLost,
            })}
          />
        ) : (
          <span className='font-semibold'>
            {t('No connection established')}
          </span>
        )}
        <div className='pt-4'>
          <div className='flex justify-between gap-x-2'>
            <div>
              <div>{t('Access ID')}</div>
              <div className='mb-2 flex items-center gap-x-2 font-semibold'>
                {jtlCredentials ? (
                  <>
                    <span>{jtlCredentials.username}</span>{' '}
                    <button
                      onClick={onClickCopy(
                        jtlCredentials.username,
                        'Access ID is copied'
                      )}
                    >
                      <CopyIcon className='h-6 w-6' />
                    </button>
                  </>
                ) : (
                  <span>{t('Not generated yet')}</span>
                )}
              </div>
            </div>
          </div>
          <JTLSecretKey
            password={password}
            jtlCredentials={jtlCredentials}
            onClickCopy={onClickCopy}
          />
        </div>
      </div>
      <Button
        disabled={isGenerating}
        className='mt-4 flex !w-full items-center justify-center gap-x-2'
        styling={jtlCredentials ? 'outline' : 'primary'}
        onClick={onClickGenerate}
      >
        {isGenerating && <Spinner />}{' '}
        <span>{t(jtlCredentials ? 'Regenerate' : 'Generate')}</span>
      </Button>
    </div>
  );
};
